// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"2993ffe3","731":"cefa9f6a","905":"ad58c1ef","981":"cdde28cf"}[chunkId] + ".chunk.js";
};